/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Finance_BodyInputs */

const en_features_finance_body = /** @type {(inputs: Features_Finance_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takings week by week, packs sold and what is left to collect. No spreadsheet, no sums in your head.`)
};

const pl_features_finance_body = /** @type {(inputs: Features_Finance_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wpływy tydzień po tygodniu, sprzedane pakiety i to, co zostało do pobrania. Bez arkusza i bez liczenia w głowie.`)
};

/**
* | output |
* | --- |
* | "Takings week by week, packs sold and what is left to collect. No spreadsheet, no sums in your head." |
*
* @param {Features_Finance_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_finance_body = /** @type {((inputs?: Features_Finance_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Finance_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_finance_body(inputs)
	return en_features_finance_body(inputs)
});